import { isSupabaseConfigured } from "@/lib/supabase/client";
import { DummyOrganizationRepository } from "@/data/repositories/dummy/dummyOrganizationRepository";
import { DummyEventRepository } from "@/data/repositories/dummy/dummyEventRepository";
import { SupabaseOrganizationRepository } from "@/data/repositories/supabase/supabaseOrganizationRepository";
import { SupabaseEventRepository } from "@/data/repositories/supabase/supabaseEventRepository";
import type { OrganizationRepository } from "@/data/repositories/organizationRepository";
import type { EventRepository } from "@/data/repositories/eventRepository";
import { DummyAuthorizationRepository } from "@/data/repositories/dummy/dummyAuthorizationRepository";
import { SupabaseAuthorizationRepository } from "@/data/repositories/supabase/supabaseAuthorizationRepository";
import type { AuthorizationRepository } from "@/data/repositories/authorizationRepository";
import { DummyEventAssetsRepository } from "@/data/repositories/dummy/dummyEventAssetsRepository";
import { SupabaseEventAssetsRepository } from "@/data/repositories/supabase/supabaseEventAssetsRepository";
import type { EventAssetsRepository } from "@/data/repositories/eventAssetsRepository";
import{DummyNotificationRepository}from"@/data/repositories/dummy/dummyNotificationRepository";import{SupabaseNotificationRepository}from"@/data/repositories/supabase/supabaseNotificationRepository";import type{NotificationRepository}from"@/data/repositories/notificationRepository";
import { DummyBillingRepository } from "@/data/repositories/dummy/dummyBillingRepository";
import { SupabaseBillingRepository } from "@/data/repositories/supabase/supabaseBillingRepository";
import type { BillingRepository } from "@/data/repositories/billingRepository";
import { DummyPlanningRecordRepository } from "@/data/repositories/dummy/dummyPlanningRecordRepository";
import { SupabasePlanningRecordRepository } from "@/data/repositories/supabase/supabasePlanningRecordRepository";
import type { PlanningRecordRepository } from "@/data/repositories/planningRecordRepository";

/**
 * Single composition point for which repository implementation the app
 * uses. Contexts import `organizationRepository` / `eventRepository` from
 * here — never a concrete Dummy* or Supabase* class directly — so
 * flipping from dummy to real data is deciding it once, here, rather than
 * hunting through every context and hook.
 *
 * Today this mirrors the same `isSupabaseConfigured` switch AuthContext
 * already uses, so all three (auth, organizations, events) flip modes
 * together the moment Supabase env vars are set.
 */
export const organizationRepository: OrganizationRepository = isSupabaseConfigured
  ? new SupabaseOrganizationRepository()
  : new DummyOrganizationRepository();

export const eventRepository: EventRepository = isSupabaseConfigured
  ? new SupabaseEventRepository()
  : new DummyEventRepository();

export const authorizationRepository: AuthorizationRepository = isSupabaseConfigured
  ? new SupabaseAuthorizationRepository()
  : new DummyAuthorizationRepository();

export const eventAssetsRepository: EventAssetsRepository = isSupabaseConfigured
  ? new SupabaseEventAssetsRepository()
  : new DummyEventAssetsRepository();
export const notificationRepository:NotificationRepository=isSupabaseConfigured?new SupabaseNotificationRepository():new DummyNotificationRepository();
export const billingRepository: BillingRepository = isSupabaseConfigured ? new SupabaseBillingRepository() : new DummyBillingRepository();
export const planningRecordRepository: PlanningRecordRepository = isSupabaseConfigured
  ? new SupabasePlanningRecordRepository()
  : new DummyPlanningRecordRepository();
